/* global journal_logs */

/* The journal manages journal_log objects */
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import JournalLogCollection from 'journal/collections/journal_log';
import JournalLogModel from 'journal/models/journal_log';
import ExtraMobileLinkView from 'core/views/extra_mobile_link';
import DateNav from 'core/controllers/date_navigation';
import GoogleAnalytics from 'core/google_analytics';


export default Backbone.View.extend({
  events: {
    'focus textarea': 'start_saving',
    'blur textarea': 'stop_saving'
  },

  initialize: function (options) {
    _.bindAll(this, 'get_log', 'render_async', 'render', 'save_log',
      'start_saving', 'stop_saving', 'log_saved');

    // store a reference to this view on the DOM element
    this.$el.data('JournalView', this);
    this.text_area = $('textarea', this.$el);
    this.saving_progress = $('.progress-loading', this.$el);
    this.alert_message = _.template($('#alert-message-template', this.$el).html())();
    this.alerted = false;
    this.parent_view = options.parent_view;

    // all the user's journals, passed to us by the Django view in the template context
    this.collection = this.parent_view.journal_collection;
    // Update journal cache when items are added or removed
    this.collection.on('add remove', function () {
      this.collection.fetch();
    }, this);

    if (options.date_nav) {
      this.date_nav = options.date_nav;
      this.date_nav.on('change', this.render_async);
    } else {
      this.date_nav = new DateNav({
        pagination: $('.date-pagination', this.el),
        pager: $('.pager', this.el),
        collection: this.collection
      });
      this.date_nav.set_navigate_by('collection');
      // Helpful little trick here. Any calls to change_date will call the
      // parent view's change_date directly and we will take our cues from
      // there.
      this.date_nav.change_date = this.parent_view.date_nav.change_date;
      this.parent_view.date_nav.on('change', function (selected_date) {
        this.date_nav.selected_date = selected_date;
        this.render_async();
      }, this);
    }
    this.date_nav.render();

    this.render();

    // Save interval handle
    this.saver = null;
  },

  get_log: function () {
    /* Return the user's journal log model instance for the selected date.
           If they don't already have one, a new one is created (unsaved).
           Even if we are taking our cues from the parent datenav, our own
           datenav should have synced the date by this point, so we get it
           from there.
           */
    var the_date = this.date_nav.formatted_date();
    var journals = this.collection.where({ date: the_date });
    return journals.length ? journals[0] : new JournalLogModel({ date: the_date });
  },

  render_async: function () {
    setTimeout(this.render, 0);
  },

  render: function () {
    // save current journal log if need be before throwing away what's displayed
    if (this.journal_log !== undefined) {
      this.save_log();
    }
    // Get and show today's journal_log, if any
    var journal_log = this.get_log();
    if (journal_log && journal_log.has('journal') && journal_log.get('journal') !== '') {
      this.text_area.val(_.unescape(journal_log.get('journal')));
    } else {
      this.text_area.val('');
    }
    this.journal_log = journal_log; // the currently displayed journal log
    this.alerted = false;

    this.date_nav.render();
  },

  save_log: function () {
    // $target should be the jquery object wrapped around the journal's TextArea element
    var journal_value = this.text_area.val();
    var journal_log = this.journal_log; // the currently displayed journal log
    var self = this;
    if (journal_log !== undefined && journal_value !== '' && journal_value !== journal_log.get('journal')) {
      this.saving_progress.addClass('active');
      setTimeout(function () {
        self.saving_progress.removeClass('active');
      }, 3000);
      journal_log.save({ journal: journal_value }, { success: this.log_saved });
    }
    return false;
  },

  log_saved: function (journal_log) {
    // If this journal entry is new sent an event to GA
    if (_.contains(_.keys(journal_log.changed), 'id')) {
      GoogleAnalytics.send_event('journal', 'created');
    }
    // now that it's saved, add it to the collection
    this.collection.add(journal_log);
    this.collection.fetch();

    // Show the alert if the journal contains a trigger word
    if (journal_log.get('alert_words').length > 0 && !this.alerted) {
      this.alerted = true;
      this.text_area.after(this.alert_message);
      // Post a Google Analytics event for each trigger word
      _.each(journal_log.get('alert_words'), function (word) {
        GoogleAnalytics.send_event('journal', 'alert', word, 1);
      });
      // Post a Google Analytics event when coach link is clicked
      var coachhub_link = $('#alert-message a', this.$el);
      coachhub_link.one('click', function (e) {
        e.preventDefault();
        GoogleAnalytics.send_event('journal', 'click', 'coachhub');
        if (!mobile) {
          // Mobile link handling via ExtraMobileLinkView
          window.location = coachhub_link.attr('href');
        }
      });
      // If in the native app, direct this link to a browser with a nonce login
      if (mobile) {
        new ExtraMobileLinkView({ el: coachhub_link });
      }
    }
  },

  start_saving: function () {
    this.saver = setInterval($.proxy(this.save_log, this), 3000);
  },

  stop_saving: function () {
    clearInterval(this.saver);
    this.save_log();
  }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/django-journal/journal/static/js/journal/views/journal.js
// module id = 151
// module chunks = 0